import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/message/TNDFTC7M6U4AI1';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-75">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-6 left-0 right-0 px-6 z-50 md:hidden flex justify-center pointer-events-none" data-id="element-76">
          <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="pointer-events-auto flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-4 rounded-full font-bold shadow-lg w-full max-w-sm active:scale-95 transition-transform" data-id="element-77">
            <MessageCircle className="w-5 h-5" data-id="element-78" />
            Hablar por WhatsApp
          </a>
        </motion.div>}
    </AnimatePresence>;
}